import { useEffect } from "react";
import { getLogoutRequest } from "./logoutRequest";
import useLogOut from "./useLogout";
export var LogoutHandler = function () {
    var doLogout = useLogOut().doLogout;
    useEffect(function () {
        var handler = function () {
            var requestData = getLogoutRequest();
            if (requestData) {
                doLogout(requestData);
            }
        };
        window.addEventListener("trigger-logout", handler);
        return function () { return window.removeEventListener("trigger-logout", handler); };
    }, [doLogout]);
    return null;
};
